import { Link } from 'react-router-dom';
import { videoCategories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-xl font-heading font-bold text-white mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors">蓝莓视频</Link>
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              高清免费在线观看平台，海量视频资源，极速不卡顿。您的随身私人影院。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-white"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              <Link to="/category/hot" className="hover:text-primary-400 transition-colors">热门分类</Link>
            </h4>
            <ul className="space-y-2.5">
              {videoCategories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {videoCategories.slice(5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              推荐平台
            </h4>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-foreground-400">红桃视频</span></li>
              <li><span className="text-sm text-foreground-400">樱花视频</span></li>
              <li><span className="text-sm text-foreground-400">糖豆视频</span></li>
              <li><span className="text-sm text-foreground-400">小蓝视频</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 蓝莓视频 LanMei Video. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}